import keyMirror from 'keymirror';

export default keyMirror({
  RECIEVE_TRANSPORTS: null,
  RECIEVE_MONTHS: null,
  RECIEVE_TRANSPORTS_ERROR: null,
  RECIEVE_MONTHS_ERROR: null
});



// WEBPACK FOOTER //
// ./src/constants/TransportConstants.js